import { AxiosErrorResponse } from '@core/error.models';
import { IApiBaseProps, IPaginatedApiProps, IPaginatedApiBaseProps, IApiBasePropsWithForm } from './api.models';
import { isPositiveNumber } from '../core/Primitives/number.services';

export const isValidApiBaseProps = (props: IApiBaseProps | undefined): boolean => {
  return !!props && isPositiveNumber(props.projectId);
};

export const isValidPaginatedApiProps = (props: IPaginatedApiProps | undefined): boolean => {
  return !!props && isPositiveNumber(props.pageNumber) && isPositiveNumber(props.pageSize);
};

export const isValidPaginatedApiBaseProps = (props: IPaginatedApiBaseProps | undefined): boolean => {
  return !!props && isValidApiBaseProps(props) && isValidPaginatedApiProps(props);
};

export const isValidApiBasePropsWithForm = (props: IApiBasePropsWithForm | undefined): boolean => {
  return !!props && isPositiveNumber(props.formId, true) && isValidApiBaseProps(props);
};

export const isRestrictedAccessFromApiResponse = (errors: (AxiosErrorResponse | undefined | null)[]) => {
  const foundRestrictedResponse = errors.find((e) => e?.response?.status === 403);
  return !!foundRestrictedResponse;
};
